import { IUserInviteDto } from 'api/users/dtos'
import { mapUserInviteFromDto } from 'api/users/helpers'
import { IUserInvite } from 'api/users/models'
import http from '../http'
import { IClientDto, ICPADto } from './dtos'
import { mapClientFromDto, mapCPAFromDto } from './helpers'
import { IClient, ICPA, InviteType } from './models'

const cpasAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/cpas`)
const clientsAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/clients`)
const invitesAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/invites`)

export const getCPAs = async () => {
	const { data } = await cpasAPI.get<ICPADto[]>('')
	return data.map(mapCPAFromDto)
}

export const getSenderInvites = async (type: InviteType) => {
	const { data } = await invitesAPI.get<IUserInviteDto[]>('/sender', { params: { type } })
	return data.map(mapUserInviteFromDto)
}

export const removeCPA = async (userId: ICPA['id']) => {
	const { data } = await cpasAPI.delete(`/${userId}`)
	return data
}

export const getCPAClients = async () => {
	const { data } = await clientsAPI.get<IClientDto[]>('')
	return data.map(mapClientFromDto)
}

export const getReceiverInvites = async (type: InviteType) => {
	const { data } = await invitesAPI.get<IUserInviteDto[]>('/receiver', { params: { type } })
	return data.map(mapUserInviteFromDto)
}

export const removeClient = async (userId: IClient['id']) => {
	const { data } = await clientsAPI.delete(`/${userId}`)
	return data
}

export const sendInvite = async ({
	email,
	type,
}: {
	email: IUserInvite['email']
	shouldRefetch?: boolean
	type: InviteType
}) => {
	const { data } = await invitesAPI.post('/send', { email, type })
	return data
}

export const acceptInvite = async (id: IUserInvite['id']) => {
	const { data } = await invitesAPI.post(`/${id}/accept`)
	return data
}

export const rejectInvite = async (id: IUserInvite['id']) => {
	const { data } = await invitesAPI.post(`/${id}/reject`)
	return data
}

export const removeInvite = async (id: IUserInvite['id']) => {
	const { data } = await invitesAPI.delete(`/${id}`)
	return data
}

export const leaveOrganization = async () => {
	const { data } = await cpasAPI.post('/leave-organization')
	return data
}
